const version = "v1";
const service = "staging";

export default {
  SIGNIN: `/api/auth/admin/send-otp`,
  LOGOUT: `${version}/${service}/auth/logout`,
  VERIFY_OTP: `/api/auth/admin/verify-otp`,
  GET_ALL_USERS: `/api/users`,
  GET_ADMIN_USERS: `/api/users/admins`,
  GET_USER_BY_TOKEN: `${version}/${service}/users/details`,
  GET_ALL_BRANDS: `/api/brands`,
  EXPORT_ALL_BRANDS: `/api/brands/export/xlsx`,
  UPLOAD_BRAND_DISCOUNT: `/api/brands/discount/upload`,
  GET_ALL_TRANSACTIONS: `/api/transactions/admin`,
  GET_TRANSACTIONS_ANALYTICS: `/api/transactions/analytics`,
  GET_FAILED_TRANSACTIONS: `/api/failed-transactions`,
  GET_FAILED_TRANSACTIONS_ANALYTICS: `/api/failed-transactions/analytics`,
  REFUND_FAILED_TRANSACTION: `/api/failed-transactions/:transactionId/refund`,
  CLOSE_FAILED_TRANSACTION: `/api/failed-transactions/:transactionId/close`,
  GET_DASHBOARD_STATS: `/api/dashboard`,
  GET_DASHBOARD_RECENT_USERS: `/api/dashboard/recent-users`,
  GET_DASHBOARD_RECENT_TRANSACTIONS: `/api/dashboard/recent-transactions`,
  GET_REVENUE_ANALYTICS: `/api/analytics/revenue`,
  GET_VOUCHERS_TOTAL: `${version}/${service}/payment/total`,
  GET_ALL_VOUCHERS_AND_ORDERS: `${version}/${service}/order/total`,
  GET_ALL_ORDERS: `/api/orders`,
  GET_USERS_ORDERS: `/api/users/orders`,
  GET_USERS_WITH_ORDERS: `/api/users/with-orders`,
  GET_ORDERS_USERS: `/api/orders/users`,
  GET_USER_ORDERS_BY_ID: `/api/users/:id/orders`,
  GET_FRAUD_USERS: `/api/fraud/users`,
  GET_USERS_FRAUD: `/api/users/fraud`,
  UPDATE_FRAUD_USER: `/api/fraud/users/:id`,
  UPDATE_USER_FRAUD: `/api/users/:id/fraud`,
  CHECK_USER_FRAUD: `/api/fraud/users/:id/check`,
  GET_ORDER_RETRY_ATTEMPTS: `/api/orders/retry/attempts`,
  RETRY_ORDER_DELIVERY: `/api/orders/retry`,
  DOWNLOAD_ORDER_INVOICE: `/api/orders/:id/invoice`,
  DOWNLOAD_ORDER_INVOICE_DOWNLOAD: `/api/orders/:id/invoice/download`,
  DOWNLOAD_ORDER_INVOICE_ADMIN: `/api/orders/admin/:id/invoice`,
  GET_ALL_SALES: `${version}/${service}/hamrahi/all`,
  UPDATE_SALES: `${version}/${service}/hamrahi/update`,
  GET_ALL_CATEGORY: `${version}/${service}/category`,
  UPDATE_CATEGORY: `${version}/${service}/voucher/update-brands`,
  ADD_BANNER: `/api/v1/staging/banner`,
  GET_ALL_COUPON: `${version}/${service}/coupon`,
  ADD_COUPON: `${version}/${service}/coupon`,
  UPDATE_COUPON: `${version}/${service}/coupon`,
  DELETE_COUPON: `${version}/${service}/coupon`,
  GET_ALL_ADMIN_USERS: `${version}/${service}/users/:id/admin`,
  ONBOARD_BACKEND_USER: `/api/auth/admin/backend-users`,
  DELET_ALL_ADMIN_USERS: `${version}/${service}/users`,
  GET_ALL_BANNER: `/api/v1/staging/banner`,
  EDIT_BANNER: `/api/v1/staging/banner`,
  BANNER_ORDER: `/api/banners/:id/order`,
  BANNER_REORDER: `/api/banners/reorder`,
  GET_WEEKLY_ORDERS: `${version}/${service}/order/weekly`,
  UPDATE_BRAND: `/api/brands`,
  UPDATE_BRAND_DISCOUNT: `/api/brands`,
  TICKET: `${version}/${service}/ticket`,
  EDIT_TICKET: `${version}/${service}/ticket/:id`,
  TICKETS: `/api/tickets`,
  TICKET_BY_ID: `/api/tickets/:id`,

  GET_WALLET: `${version}/${service}/wallet/reward-point`,
  GET_REWARDS_HISTORY: `/api/rewards`,
  GRANT_REWARD: `/api/rewards/grant`,
  COMMENTS: `${version}/${service}/comment/`,
  GET_ALL_CLIENTS: `${version}/${service}/business/getAllBusinessAccountUsers`,
  GET_CLIENTS_BY_ID: `${version}/${service}/business/getBusinessAccountUserById/`,
  UPDATE_CLIENTS_BY_ID: `${version}/${service}/business/updateBusinessUserById/`,

  ADD_SPECIAL_COUPON: `${version}/${service}/coupon/specialCoupons`,
  APPLY_PERMISSIONS: `${version}/${service}/business/addGrantPermission`,
  ADD_BRANDS: `${version}/${service}/business/addBrandInBusinessAccount`,
  UPLOAD_DOC: `${version}/${service}/companyDetails/uploadDocument`,
  UPLOAD_FILE: `${version}/${service}/upload-file`,
  GET_RECHARGE_REQUEST: `${version}/${service}/recharge/getRechargeRequestsByBusinessAccountId/`,
  UPDATE_RECHARGE_REQUEST_STATUS: `${version}/${service}/recharge/verifyRechargeRequests/`,
  GET_ALL_CAMPAIGN_LEADS: `${version}/${service}/contact/getAllContacts`,
  GET_ALL_BUDGETREE_LEADS: `${version}/${service}/contact/contactSales`,
  GET_FLIPKART_BALANCE: `/api/flipkart/balance`,
  GET_WOOHOO_WALLET_BALANCE: `/api/woohoo/wallet-balance`,
  GET_GYFTR_WALLET_BALANCE: `/api/gyftr/wallet/checkbalance`,
  GET_HUBBLE_BALANCE: `https://api.siripay.in/api/hubble/balance`,
  IMAGE_UPLOAD: `${version}/${service}/upload-file`,
  HELP_SUPPORT_QUERIES: `/api/help-and-support/queries`,

  // Experience Admin APIs
  EXPERIENCES_ADMIN: `/api/admin/experiences`,
  EXPERIENCE_ADMIN_BY_ID: `/api/admin/experiences/:id`,
  EXPERIENCE_ADMIN_STATUS: `/api/admin/experiences/:id/status`,

  // Experience Public / Catalog APIs
  EXPERIENCES_PUBLIC: `/api/experiences`,
  EXPERIENCE_PUBLIC_BY_ID: `/api/experiences/:id`,

  // Experience Orders APIs
  EXPERIENCE_ORDERS_ADMIN: `/api/admin/experiences/orders`,
  EXPERIENCE_ORDER_ADMIN_BY_ID: `/api/admin/experiences/orders/:id`,
  EXPERIENCE_ORDER_ADMIN_STATUS: `/api/admin/experiences/orders/:id/status`,
  EXPERIENCE_ORDER_ADMIN_CONFIRM: `/api/admin/experiences/orders/:id/confirm`,
  EXPERIENCE_ORDERS_CREATE: `/api/experiences/orders`,
  EXPERIENCE_ORDERS_MY: `/api/experiences/orders/my-orders`,
  EXPERIENCE_ORDER_PUBLIC_BY_ID: `/api/experiences/orders/:id`,
  EXPERIENCE_ORDER_CONFIRM: `/api/experiences/orders/:id/confirm`,

  // Featured Section APIs
  FEATURED_SECTION: `/api/featured-section`,
  FEATURED_SECTION_METADATA: `/api/featured-section/section`,
  FEATURED_SECTION_TITLE: `/api/featured-section/title`,
  FEATURED_ITEMS: `/api/featured-section/items`,
  FEATURED_ITEM_BY_ID: `/api/featured-section/items/:id`,
  FEATURED_ITEM_ORDER: `/api/featured-section/items/:id/order`,
  FEATURED_ITEMS_REORDER: `/api/featured-section/items/reorder`,
};
